// extracted by mini-css-extract-plugin
export default {"usersTable":"SalesByLocations_usersTable__H6sqn"};